export const environment = {
  production: false,
  apiUrl: 'https://finbox-api.onrender.com',
  featureX: true
};